import './App.css';
import { Routes, Route } from 'react-router-dom';
import Header from './Header';
import HomePage from './HomePage';
import AboutUs from './AboutUs';
import Trainers from './Trainers';
import Courses from './Courses';
import Tests from './Tests';
import Contact from './Contact';
import WhatsAppButton from './WhatsAppButton';

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/trainers" element={<Trainers />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/tests/icdl" element={<Tests />} />
        <Route path="/tests/ielts" element={<Tests />} />
        <Route path="/tests/toefl" element={<Tests />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <WhatsAppButton />
    </div>
  );
}

export default App;
